import React from "react";
import {Navigate, useLocation} from "react-router-dom"
import { logger } from "../utilities/logger";


function ProtectedRoute({ children }) {
  const isAuthenticated = localStorage.getItem("isAuthenticated");
  logger.debug("ProtectedRoute isAuthenticated:", isAuthenticated);

  let location = useLocation();

    if(!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location}} replace />
    }
 return children
}

export default ProtectedRoute;